import React, { useState } from 'react';

export default function ExpandingTextArea(props) {
    const { rows, maxRows } = props;

    const initialState = {
        numberOfRows: rows || null,
        minimumRows: rows || 1,
        maximumRows: maxRows || 10,
    };

    const [state, updateState] = useState(initialState);

    function handleChange(event) {
        const textareaLineHeight = 24;
        const { minimumRows, maximumRows } = state;

        const previousRows = event.target.rows;
        // Reset number of rows in textarea
        event.target.rows = minimumRows;

        // ~~ is a substitute for Math.floor()
        const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

        if (currentRows === previousRows) {
            event.target.rows = currentRows;
        }

        if (currentRows >= maximumRows) {
            event.target.rows = maximumRows;
            event.target.scrollTop = event.target.scrollHeight;
        }

        const newRowCount =
            currentRows < maximumRows ? currentRows : maximumRows;

        // Update the row state
        updateState({ ...state, numberOfRows: newRowCount });
    }

    const { numberOfRows, minimumRows } = state;

    return (
        <div onChange={handleChange} onFocus={handleChange}>
            <textarea
                {...props}
                rows={numberOfRows ? numberOfRows : minimumRows}
            />
        </div>
    );
}
